export default {
	title: "Etapas del Viaje",
	description: "Gestión de etapas del viaje espiritual",
	category: {
		label: "Categoría",
		MEDIUNICA: "Mediúmnica",
		RITUALISTICA: "Ritualística",
		FORMACAO: "Formación",
	},
	requiredStage: "Prerrequisito",
	requiredStageHint: "Marco que la persona debe haber completado primero",
	associatedPeople: "Médiums en: {name}",
	confirmDeleteAssignment: "¿Está seguro de que desea desvincular a {person} de la etapa \"{stage}\"?",
	confirmDeleteMessage: "¿Está seguro de que desea eliminar la etapa \"{name}\"? Esta acción no se puede deshacer.",
	confirmDeleteWithPeopleMessage: "La etapa \"{name}\" aún tiene médiums vinculados. ¿Desea eliminarla de todos modos? Los vínculos serán eliminados también.",
	createStage: "Nueva Etapa",
	createSuccess: "¡Etapa mediúmnica creada con éxito!",
	deleteError: "Error al eliminar etapa mediúmnica",
	deleteSuccess: "¡Etapa mediúmnica eliminada con éxito!",
	empty: {
		description: "Registre las etapas de desarrollo espiritual de su templo",
		title: "Ninguna etapa mediúmnica encontrada",
	},
	hasAssociatedPeopleDetailed: "Existen {active} vínculo(s) activo(s) y {inactive} inactivo(s) en esta etapa. Desvincúlelos antes de eliminar.",
	name: "Nombre",
	noAssociatedPeople: "Ningún médium vinculado a esta etapa",
	order: "Orden",
	stats: {
		avgPerStage: "Media/Etapa",
		totalPeople: "Personas",
		totalStages: "Etapas",
	},
	updateSuccess: "¡Etapa mediúmnica actualizada con éxito!",
	viewActiveAssociated: "Ver activos",
};
